<div class="user-dialog">
    <h2>{{ data.mode === 'view' ? 'Information utilisateur' : 'Modifier utilisateur' }}</h2>

    <form [formGroup]="form" class="form-fields">

        <!-- IDENTITÉ + IDENTITÉ CENTREX -->
        <div class="identity-container">
            <!-- IDENTITÉ -->
            <mat-card class="identity-card">
                <div class="section-title">Identité</div>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Nom</mat-label>
                    <input matInput formControlName="lastName" placeholder="Nom" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Prénom</mat-label>
                    <input matInput formControlName="firstName" placeholder="Prénom" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="email" placeholder="Email" />
                </mat-form-field>
            </mat-card>

            <!-- IDENTITÉ CENTREX -->
            <mat-card class="identity-card">
                <div class="section-title">Identité Centrex</div>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Extension</mat-label>
                    <input matInput [value]="data.user.number" disabled />
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Identifiant</mat-label>
                    <input matInput [value]="data.user.account" disabled />
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Site</mat-label>
                    <input matInput [value]="data.user.siteName || '—'" disabled />
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>N° personnalisé</mat-label>
                    <input matInput [value]="data.user.number || '—'" disabled />
                </mat-form-field>
            </mat-card>
        </div>

        <!-- ACTIF-->
        <div class="user-status">
            <mat-slide-toggle class="primary-button" formControlName="enabled">Actif</mat-slide-toggle>
        </div>

        <!-- HISTORIQUE -->
        @if(data.mode === 'view') {
        <mat-card>
            <app-historique [uidObject]="data.user.id" [limit]="5" />
        </mat-card>
        }

        <!-- ACTIONS -->
        <div class="dialog-actions">
            <button mat-stroked-button class="accent-button" (click)="close()">Fermer</button>
            @if (data.mode === 'edit') {
            <button mat-raised-button class="accent-button" style="margin-left: 20px;" color="accent"
                (click)="onSubmit()">Modifier</button>
            }
        </div>

    </form>
</div>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.8)" color="#00D2B4" size="large" type="timer"
    [fullScreen]="false"></ngx-spinner>